import type { TagDemographic } from 'tags';

// Legacy format returned by existing backend public report endpoints.
type LegacyTagCount = { tagId: number; tagName: string; count: number };
type LegacyTagCategoryDemographics = { categoryId: number; tagCategoryType: string; tags: LegacyTagCount[] };

export const transformDemographicsResponse = (response: LegacyTagCategoryDemographics[]): TagDemographic[] =>
  (response ?? []).map(({ tagCategoryType, tags }) => ({
    categoryName: tagCategoryType,
    tags: tags.map(({ tagName, count }) => ({ tagName, count })),
  }));
